import { Controller } from "stimulus"


export default class extends Controller {
    initialize() {

    }

    connect() {
        this.tocLinks = this.element.querySelectorAll('a'); 
        this.tocLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();

                const targetId = link.getAttribute('href').substring(1);

                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.offsetTop - 130,  
                        behavior: 'smooth'  
                    });
                }
            });
        });
    }
}